import Repository from './Repository';

const resource = '/point';

export default {
  /**
   * ポイント情報
   */
  get(): Promise<{ total: number; endOfMonthTotal: number }> {
    return Repository.get(`${resource}`);
  },

  /**
   * ポイント履歴一覧
   */
  getTransfer(from: number, limit: number): Promise<{ pointTransfers: PointTransfer[] }> {
    return Repository.get(`${resource}/transfer`, { params: { from, limit } });
  },

  /**
   * ポイント履歴詳細
   * @param transferId
   */
  getTransferDetail(transferId: string) {
    return Repository.get(`${resource}/transfer/${transferId}`);
  },

  /**
   * ポイントアクションを実行
   * @param actionId
   * @param token
   * @param shopChId
   * @param lat CS-8234
   * @param lng CS-8234
   */
  action(
    actionId: string,
    token: string | null = null,
    shopChId: string | null = null,
    lat: number | null = null,
    lng: number | null = null
  ): Promise<{
    point: number;
    type: 'GRANT' /* | 'RECEIVE */;
    line: {
      link: string;
      displayName: string;
      pictureUrl?: string;
    };
  }> {
    return Repository.post(`${resource}/action/${actionId}`, { token, shopChId, lat, lng });
  },
};

export type PointTransfer = {
  id: string;
  orgId: string;
  channelId: string | null;
  customerId: string;
  walletId: string;
  point: number;
  purpose: string;
  transactions: string[];
  createdAt: Date;
  updatedAt: Date;
  __typename: 'PointTransfer';
};
